import { defineComponent, reactive, useContext, useCssModule } from '@nuxtjs/composition-api';
import { DESKTOP_ID, MOBILE_ID, SCRIPT_PATH } from './';
import { ADFOX_FETCH_STATES } from '~/components/Adfox';
export default defineComponent({
    name: 'Infox',
    setup(_, { emit }) {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        const context = useContext();
        const currentId = context.$viewport.isLessThan('tablet') ? MOBILE_ID : DESKTOP_ID;
        const scriptSrc = SCRIPT_PATH + currentId;
        const error = reactive({});
        const state = reactive({ ...ADFOX_FETCH_STATES });
        function initInfox() {
            state.isLoaded = true;
            const key = `infoxContextAsyncCallbacks${currentId}`;
            window[key] = window[key] || [];
            window[key].push(function () {
                let gel = null;
                let toElem;
                window[`INFOX${currentId}`].renderTo = function (className) {
                    const cont = document.querySelectorAll(className);
                    for (let i = cont.length - 1; i >= 0; i--) {
                        if (!cont[i].innerHTML.length) {
                            toElem = cont[i];
                            /* eslint-disable-next-line */
                            gel = cont[i];
                        }
                    }
                    if (!toElem) {
                        return;
                    }
                    toElem.classList.remove(`infox_${currentId}`);
                    const ctx = Object.create({ ...window[`InfoxCtx${currentId}`] });
                    ctx.init(toElem);
                };
                window[`INFOX${currentId}`].renderTo(`.infox_${currentId}`);
            });
            state.isRendered = true;
            state.isCompleted = true;
            emit('complete', { error, state });
        }
        function throwError(message = '', payload = '') {
            state.withError = true;
            error.message = message;
            console.error('[Infox]', message, payload);
        }
        function handleIntersect({ observer }) {
            const script = document.createElement('script');
            script.async = true;
            script.src = scriptSrc;
            script.onerror = () => {
                return throwError(`Error in script "${scriptSrc}"`);
            };
            const scriptEl = document.head.querySelector(`script[src="${scriptSrc}"]`);
            if (scriptEl) {
                document.head.replaceChild(script, scriptEl);
            }
            else {
                document.head.append(script);
            }
            initInfox();
            observer.disconnect();
        }
        return {
            css,
            currentId,
            error,
            handleIntersect,
            state,
        };
    },
});
